import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { DrivingBehaviorFieldName } from '@app/pages/kpi-data-mgmt/driving-behavior/driving-behavior.constant';
import { AngularMaterialModule } from '@app/shared/modules/angular-material.module';
import { DynamicPipe } from '@app/shared/pipes/dynamic-pipe';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-driving-behavior-data-grid-cell',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AngularMaterialModule, CommonModule, TranslateModule, DynamicPipe],
  template: `
  @if(data[field] === ''){
    <div></div>
  }
  @else {
    @switch (field) {
      @case (drivingBehaviorFieldName.videoUrl){
        <a [href]="data[field]" target="_blank">{{'ml_143965' | translate}}</a>
      }

      @default {
        <div [innerHtml]="data[field] | dynamicPipe: column.pipe: column.pipeArgs"></div>
      }
    }
  }

  `
})
export class DrivingBehaviorDataGridCell implements OnInit {
  @Input() data: any;
  @Input() field: string;
  @Input() column: any;

  drivingBehaviorFieldName = DrivingBehaviorFieldName;

  constructor() { }

  ngOnInit() { }


}
